import React, { useEffect, useRef, useState } from "react";
import Button from "../modules/Button";
import tick from "../../Assets/svg/green-bg-tick.svg";
import ModalComponent from "../modules/Modal";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { addAllIncomeInfo } from "../IncomeDetails/redux/actions";
import { addAllPersonalInfo, isModified } from "../PersonalInfo/redux/actions";
import { addAllEduInfo } from "../Education/redux/actions";
import { useNavigate } from "react-router-dom";

import { doLogout } from "../LoginPage/redux/actions";
import { addStatusInfo } from "../WelcomeBack/redux/actions";
import TransitionAlerts from "../modules/Alerts";
import GradientLoader from "../modules/Loader";
function BtnSet(props) {
  const navigate = useNavigate();
  const myRef = useRef(null);
  const dispatch = useDispatch();
  const [Link, setLink] = useState("");
  const tokenData = useSelector((state) => state.tokens.tokens);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [Err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const spoc = useSelector((state) => state.spoc);
  const eduInfo = useSelector((state) => state.education.eduInfo);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "",
    title: "Are you sure you would like leave?",
    countDown: " ",
    desc: "All your progress has been saved.",
  });

  const CancelData = () => {
    if (ModalData.type === "") {
      setModalData({
        show: false,
        type: "cancel",
        title: "Are you sure you would like leave?",
        countDown: " ",
        desc: "All your progress has been saved.",
      });
    } else {
      setModalData({
        show: false,
        type: "cancel",
        title: "Are you sure you would like leave?",
        countDown: " ",
        desc: "All your progress has been saved.",
      });
    }
  };
  const cancelSession = () => {
    // if (Link.split("/")[2] === "") {
    setModalData({
      ...ModalData,
      type: "cancel",
      show: true,
      title: "Are you sure you would like leave?",
      countDown: " ",
      desc: "All your progress has been saved.",
    });
    // } else {
    //   let url = GetBaseUrl(window.location.href);
    //   window.location.replace(url + "/application/status");
    // }
  };

  const CombineData = () => {
    let data = {
      sfdcStudentId: null,
      campusName: spoc.pageInfo.campus || eduInfo?.campus,
    };
    let panCardInfo = null;
    let spocInfo = {
      firstName: spoc.pageInfo.firstName,
      lastName: spoc.pageInfo.lastName,
      email: spoc.pageInfo.email,
      phone: spoc.pageInfo.mobile,
    };
    let bankDetails = null;
    if (!tokenData?.totalLoginResponse?.collegeBankDetailsUpdated) {
      bankDetails = {
        name: spoc.pageInfo.bankName,
        accountName: spoc.pageInfo.accName,
        accountNumber: spoc.pageInfo.accNo,
        branchName: spoc.pageInfo.branchName,
        ifscCode: spoc.pageInfo.ifscCode,
      };
    }
    data = {
      ...data,
      panCardInfo: panCardInfo,
      spocInfo: spocInfo,
      bankDetails: bankDetails,
    };

    return data;
  };

  const submitData = async () => {
    try {
      const users = await api.collegeEmpanelment(
        CombineData(),
        tokenData.token,
        tokenData.applicationData.id
      );
      return users;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  };

  const appSubmit = async () => {
    try {
      const users = await submitData();
      return users;
    } catch (err) {
      console.log("err", err);
    }
  };

  const sendSpoc = async () => {

    if (ModalData.type === "") {
      setModalData({
        show: true,
        type: "confirm",
        title: "Are you sure you would like submit the form",
        countDown: " ",
        desc: "Once submitted, you can’t change the college bank account details",
      });
    } else if (ModalData.type === "confirm") {
      try {
        setLoading(true);
        let users = await appSubmit();
        if (users?.statusCode == 200) {
          setLoading(false);
          // else if (ModalData.type === "confirm") {
          setModalData({
            ...ModalData,
            show: true,
            title: "",
            desc: "",
            type: "submit",
          });
         
          setAlert(true);
          setTimeout(() => setAlert(false), 3000);
        } else {
          setLoading(false);
          // alert("Sorry! Something went wrong. Kindly Submit again.");
        }
      } catch (e) {
        alert("Sorry! Something went wrong. Kindly Submit again.");
      }
    } else if (ModalData.type === "submit") {
      setModalData({
        show: false,
        type: "",
        title: "",
        countDown: " ",
        desc: "",
      });
    dispatch(addTokenInfo(["showSpoc", true]));
    dispatch(addTokenInfo(["showBank", true]));
    let url = GetBaseUrl(window.location.href);
    navigate("/application/submitted-status");
     
    } else if (ModalData.type === "cancel") {
      let url = GetBaseUrl(window.location.href);
      navigate("/application/submitted-status");
      // window.location.replace(url + "/application/submitted-status");
    } else {
      setModalData({ ...ModalData, show: false });
      setLoading(true);
    }

  };
  
  const nextPage = async () => {
    // setLoading(true);
    let currentUrl = window.location.href.replace(
      /^(https?:\/\/)?(www\.)?/i,
      ""
    );
    if (!tokenData?.totalLoginResponse?.collegeBankDetailsUpdated) {
      if (!currentUrl.split("/")[3] || currentUrl.split("/")[3] === "bank") {
        let url = GetBaseUrl(window.location.href);
        // window.location.replace(url + "/application/disburse-form/spoc");
        navigate("/application/disburse-form/spoc");
      } else
       if (currentUrl.split("/")[3] === "spoc") {
        sendSpoc()
       
      }
    } else {
    sendSpoc()
    console.log("ModalData.type", ModalData.type);
  };
}
  useEffect(() => {
    if (ModalData.countDown > 0) {
      myRef.focus = setTimeout(
        () =>
          setModalData({ ...ModalData, countDown: ModalData.countDown - 1 }),
        1000
      );
    } else if (ModalData.countDown === 0) {
      // dispatch(doLogout());
      let url = GetBaseUrl(window.location.href);
      navigate("/application/status");
      // window.location.replace(url + "/application/status");

      //   setModalData({ ...ModalData, countDown: '' })
    }
  }, [ModalData]);
  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setLink(cleanedUrl);
  }, []);
  useEffect(() => {
    console.log("docs", docs);
  }, [docs]);

  useEffect(() => {
    for (let i in props.errList) {
      if (props.errList[i] === true) {
        setErr(true);
      }
    }
    // console.log('err',props.errList)
  }, [props?.errList]);

  return (
    <div className="btn-set">
      <Button
        disabled={Err}
        onClickHandler={() => cancelSession()}
        type={"contained override"}
        value={"Back to home"}
      />
      {/* <div className="ack-text">Saved 5 seconds ago</div> */}
      <Button
        type={"contained"}
        disabled={
          !tokenData?.totalLoginResponse?.collegeBankDetailsUpdated
            ? (!Link.split("/")[3] || Link.split("/")[3] === "bank") &&
              spoc?.total?.bank === 100
              ? false
              : Link.split("/")[3] === "spoc" && spoc?.total?.spocTotal === 100
              ? false
              : true
            : spoc?.total?.spocTotal === 100
            ? false
            : true
        }
        // disabled={false}
        value={"Submit"}
        // disabled={Link.split("/")[2] === "review" && percentage !== 100}
        onClickHandler={() => nextPage()}
      />
      {/* </div> */}
      {ModalData.show && (
        <ModalComponent
          className={"disburse-model"}
          show={ModalData.show && !loading}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          noCross={ModalData.type === "submit" && true}
          // countDown={ModalData.countDown}
        >
          {ModalData.type === "submit" ? (
            <div className="modal-set">
              <div>
                <img src={tick} alt="tick" />
              </div>
              <div className="md-title">
              Your Document has been uploaded successfully!
              </div>
              {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
              <div className="modal-btn-set">
                <Button
                  onClickHandler={() => nextPage()}
                  type={"contained "}
                  value={ModalData.type === "confirm" ? "Yes, Submit" : "Yes"}
                />
              </div>
            </div>
          ) : (
            <div className="modal-btn-set">
              <Button
                onClickHandler={() =>
                  setModalData({
                    ...ModalData,
                    show: false,
                    title: "",
                    desc: "",
                    type: "",
                  })
                }
                type={"contained override"}
                value={"No"}
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={
                  ModalData.type === "confirm"
                    ? "Yes, Submit"
                    : ModalData.type === "cancel"
                    ? "Yes"
                    : "Okay"
                }
              />
            </div>
          )}
        </ModalComponent>
      )}
      {alertType.msg && (
        <TransitionAlerts isAlert={alert} message={alertType.msg} />
      )}
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default BtnSet;
